export default "__VITE_ASSET__f66ac9f1__"